// extracted by mini-css-extract-plugin
export default {"tabContainer":"index_tabContainer__Jqlay"};